import PatternTop from '../../assets/img/pattern-top.svg';
import WomanVR from '../../assets/img/hero-section-image-vr-woman.webp';
import BottomRightTransition from '../../assets/img/section-transitions/hero-bottom-right.svg';
import { useTranslation, Trans } from 'react-i18next';

const Hero = ({ enableGlow = true }) => {
    const { t } = useTranslation();

    return (
        <div
            className="pt-20 md:pt-30 bg-primary-background min-h-[600px] bg-no-repeat bg-top relative overflow-hidden flex flex-col lg:flex-row items-center justify-center text-center md:text-left"
            style={{ backgroundImage: `url(${PatternTop})` }} id='hero'
        >
            {/* Bottom Right Transition Effect */}
            <img
                src={BottomRightTransition}
                alt="Transition Effect"
                width={394}
                height={75}
                className="absolute bottom-[-2px] right-0 w-[50%] max-w-[400px] md:w-[30%] z-20"
            />

            {/* Radial Glow Effects */}
            {enableGlow && (
                <>
                    {/* Top-Left Glow */}
                    <div className="absolute left-0 top-[-20%] w-[60%] md:w-[50%] h-[250px] md:h-[300px] bg-white opacity-40 md:opacity-60 blur-2xl md:blur-3xl z-0 rounded-[50%]"></div>
                    {/* Large Left Glow */}
                    <div className="absolute left-[-150px] md:left-[-200px] top-[50%] w-[450px] md:w-[600px] h-[450px] md:h-[600px] rounded-full bg-white opacity-40 md:opacity-60 blur-2xl md:blur-3xl z-0 transform -translate-y-1/2"></div>
                    {/* Small Left Glow */}
                    <div className="absolute left-[50px] md:left-[100px] top-[60%] w-[250px] md:w-[350px] h-[250px] md:h-[350px] rounded-full bg-white opacity-30 md:opacity-40 blur-xl md:blur-3xl z-0 transform -translate-y-1/2"></div>
                </>
            )}

            {/* Text Content */}
            <div className="max-w-[90%] md:max-w-200 flex flex-col items-center md:items-start gap-6 md:gap-13 relative z-10">
                <h1 className="text-[42px] md:text-[80px] leading-tight mt-12 md:mt-0">
                    <Trans
                        i18nKey="hero.title"
                        components={[
                            <span key="highlight" className="text-primary" />
                        ]}
                    />
                </h1>
                <p className="text-lg md:text-2xl max-w-[90%] md:max-w-[600px]">
                    {t('hero.subtitle')}
                </p>
                <a href="#jak-to-funguje" className="btn px-6 py-3 md:px-10 md:py-4 text-lg md:text-xl">
                    {t('hero.getStarted')}
                </a>
            </div>

            {/* VR Woman Image */}
            <div className="relative mt-10 md:mt-0">
                {enableGlow && (
                    <>
                        <div className="absolute right-[-20px] md:right-[-40px] top-[-20px] md:top-[-30px] w-[350px] md:w-[500px] h-[350px] md:h-[500px] rounded-full opacity-40 md:opacity-50 bg-white blur-xl md:blur-3xl z-0"></div>
                        <div className="absolute left-[-20px] md:left-[-40px] bottom-[-20px] md:bottom-[-30px] w-[350px] md:w-[500px] h-[350px] md:h-[500px] rounded-full opacity-40 md:opacity-50 bg-white blur-xl md:blur-3xl z-0"></div>
                    </>
                )}

                <img
                    src={WomanVR}
                    alt={t('hero.imageAlt')}
                    width={941}
                    height={946}
                    loading="eager"
                    fetchPriority="high"
                    className="relative bottom-[-15px] z-10 max-w-[500px] md:max-w-120 xl:max-w-160"
                />
            </div>
        </div>
    );
};

export default Hero;
